module.exports = __webpack_public_path__ + "img/arenda-logo.ecd9a23f.png";